// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","569":"b548615e","642":"94a7ad86","768":"component---src-templates-task-template-service-template-tsx","947":"e999873e"}[chunkId] + "-" + {"351":"63c18f123b46527f3dec","569":"2bfb7c24a60ac5d36d24","642":"4815fbbf204c1b708581","768":"c96f2fe722c1da9215f6","947":"2b7ef2e474bd5300d593"}[chunkId] + ".js";
};